import React from 'react';
import {
  Select,
  MenuItem,
  withStyles,
  makeStyles,
  useMediaQuery,
} from '@material-ui/core';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { SearchfilterIcon } from '../../constants';

const StyledSelect = withStyles((theme) => ({
  root: {
    background: 'transparent',
    minWidth: '115px',
    [theme.breakpoints.down('md')]: {
      minWidth: '75px',
      maxWidth: '75px',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '115px',
      maxWidth: '115px',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '75px',
      maxWidth: '75px',
    },
    paddingLeft: '16px',
    '&:focus': {
      background: 'transparent',
    },
  },
}))(Select);

const StyledMenuItem = withStyles(() => ({
  root: {
    '&:not(:last-child)': {
      borderBottom: '0.25px solid rgba(109, 125, 139, 0.2)',
    },
    '&:focused': {
      background: 'red',
    },
    // padding: '10px 8px',
    padding: (props) => (props.arReports ? '8px' : '10px 8px'), // Conditional removed ar report dropdown
    color: 'rgba(109, 125, 139, 1)',
    size: '14px',
    fontWeight: (props) => props.arReports && '400',
  },
}))(MenuItem);

const SelectComp = ({
  handleChange,
  searchType,
  disable,
  usedIn,
  isMobileView,
  menuItems,
  showSmFilterIcon,
  isFromQuickCheckout,
  // prop from ar report component for conditional styling
  arReports,
}) => {
  const useStyles = makeStyles((theme) => ({
    selected__menu__item: {
      backgroundColor: 'white',
      '&.Mui-selected': {
        backgroundColor: 'white',
      },
      [theme.breakpoints.down('sm')]: {
        // background: 'red',
      },
    },
    main__search: {
      border: '0.5px solid #6D7D8B',
      borderRadius: '100px',
      height: '40px',
      marginLeft: usedIn === 'estimateStatus' ? '0' : '1rem',
      padding: '0 1rem',
      color: '#263238',
      fontSize: '14px',
      fontWeight: '500',
      width: isMobileView ? '100%' : '10rem',
      '& .MuiSelect-selectMenu': {
        padding: '0 12px 0 0',
        // height: '100%',
        // display: 'flex',
        // alignItems: 'center',
      },
      '& .MuiSvgIcon-root': {
        right: '10px',
      },
    },
    vehicle__earch: {
      fontWeight: 500,
    },
  }));
  const classes = useStyles();
  const [expand] = React.useState(false);
  const matches = useMediaQuery('(max-width:959px)');

  const getIcon = () => {
    return (matches && showSmFilterIcon) || isFromQuickCheckout
      ? SearchfilterIcon
      : expand
      ? ExpandLessIcon
      : ExpandMoreIcon;
  };
  return (
    <StyledSelect
      disabled={disable}
      value={searchType}
      onChange={(e) => handleChange(e.target.value)}
      disableUnderline
      className={clsx(
        usedIn === 'estimateStatus' && classes.main__search,
        usedIn === 'vehicleSearch' && classes.vehicle__earch,
        'ar__drop__down',
      )}
      IconComponent={getIcon()}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
        PaperProps: {
          style: {
            borderRadius: '15px',
            padding: arReports ? '' : '0 15px',
            marginTop: arReports ? '8px' : '15px',
            background: '#fff',
            left: '128px',
            border: '1px solid rgba(221, 233, 251, 1)',
            boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
          },
        },
        ListProps: {
          style: {
            paddingTop: '0px', // Remove top padding
            paddingBottom: '0px', // Remove bottom padding
          },
        },
      }}
    >
      {menuItems?.map((itms, i) => {
        return (
          <StyledMenuItem
            value={itms.value}
            className={classes.selected__menu__item}
            key={i++}
            arReports={arReports} // arReports for styling
          >
            {itms.label}
          </StyledMenuItem>
        );
      })}
    </StyledSelect>
  );
};

export default SelectComp;
